import { useQuery } from "react-query";
import { fetchCompsData } from "./api";

export function useComps(filters, options = {}) {
  return useQuery(["fetchCompsData", filters], () => fetchCompsData(filters), {
    staleTime: 60000 * 60,
    ...options,
  });
}
